import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { RenderInput } from '../../model/FieldConfig';

interface Props {
    show: boolean;
    onClose: () => void;
    onSubmit: (data: any) => void;
    editingRawMaterial: any;
    rawMaterialFields: any[];
}

const AddEditRawMaterialModal: React.FC<Props> = ({
    show,
    onClose,
    onSubmit,
    editingRawMaterial,
    rawMaterialFields
}) => {
    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors }
    } = useForm<any>({
        mode: 'onChange',
        defaultValues: editingRawMaterial || {}
    });

    // Reset form when modal opens/closes or editingRawMaterial changes
    useEffect(() => {
        if (show) {
            if (editingRawMaterial) {
                // Reset with editing raw material data
                reset(editingRawMaterial);
            } else {
                // Reset to empty values for new entry
                const emptyValues = rawMaterialFields.reduce((acc, field) => {
                    acc[field.name] = "";
                    return acc;
                }, {} as any);
                reset(emptyValues);
            }
        }
    }, [show, editingRawMaterial, reset, rawMaterialFields]);

    const handleClose = () => {
        // Reset form before closing
        reset();
        onClose();
    };

    const handleFormSubmit = (data: any) => {
        // If editing, ensure we have the id
        if (editingRawMaterial) {
            data.id = editingRawMaterial.id;
        }
        onSubmit(data);
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>{editingRawMaterial ? 'Edit Raw Material' : 'Add Raw Material'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row g-2">
                    {rawMaterialFields?.map((f: any) => (
                        <RenderInput
                            key={f.name}
                            placeholder={`Enter ${f.label}`}
                            field={f}
                            register={register}
                            errors={errors}
                            control={control}
                        />
                    ))}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn add-btn" onClick={handleClose}>
                    Cancel
                </button>
                <button
                    type="button"
                    className="btn submit-btn"
                    onClick={handleSubmit(handleFormSubmit)}
                >
                    {editingRawMaterial ? 'Update' : 'Add'}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddEditRawMaterialModal;